"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _EmailCaptureVariants = _interopRequireDefault(require("./EmailCaptureVariants"));

var _storageUtils = require("./utils/storageUtils");

var _strings = require("../../utils/strings");

require("./EmailCapture.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var EmailCapture = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(EmailCapture, _React$Component);

  var _super = _createSuper(EmailCapture);

  function EmailCapture(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, EmailCapture);
    _this = _super.call(this, props);
    var delay = props.delay;
    var isVisible = delay && delay <= 0;
    _this.state = {
      isVisible: isVisible,
      isSubmitting: false,
      isSuccess: false,
      formFieldValues: {},
      errors: {}
    };
    _this.clearError = _this.clearError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getErrors = _this.getErrors.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clearInputs = _this.clearInputs.bind((0, _assertThisInitialized2["default"])(_this));
    _this.submitForm = _this.submitForm.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateFormFields = _this.updateFormFields.bind((0, _assertThisInitialized2["default"])(_this));
    _this.closeEmailCapture = _this.closeEmailCapture.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateVisibility = _this.updateVisibility.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleVisibility = _this.toggleVisibility.bind((0, _assertThisInitialized2["default"])(_this));
    _this.formOnSuccess = _this.formOnSuccess.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(EmailCapture, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var locationId = this.props.locationId; // If it hasn't been submitted, then display

      if (!(0, _storageUtils.formWasSubmitted)(locationId)) {
        this.toggleVisibility();
      }
    }
  }, {
    key: "getErrors",
    value: function getErrors() {
      var fields = this.props.fields;
      var formFieldValues = this.state.formFieldValues;
      var errors = {};
      fields.forEach(function (field) {
        var key = field.key;
        var value = formFieldValues[key];

        if (!value) {
          errors[key] = 'Please enter a valid value';
        }

        if (key === 'email' && !(0, _strings.isValidEmail)(value)) {
          errors[key] = 'Please enter a valid email';
        }
      });
      return errors;
    }
  }, {
    key: "clearError",
    value: function clearError(key) {
      var errors = this.state.errors;
      delete errors[key];
      this.setState({
        errors: errors
      });
    }
  }, {
    key: "formOnSuccess",
    value: function formOnSuccess() {
      var _this$props = this.props,
          closeDelay = _this$props.closeDelay,
          locationId = _this$props.locationId;
      this.setState({
        isSubmitting: false,
        isSuccess: true,
        formFieldValues: {}
      });
      (0, _storageUtils.setFormAsSubmitted)(locationId);
      this.closeEmailCapture(closeDelay * 1000);
    }
  }, {
    key: "updateVisibility",
    value: function updateVisibility(isVisible) {
      this.setState({
        isVisible: isVisible
      });
    }
  }, {
    key: "clearInputs",
    value: function clearInputs() {
      this.setState({
        formFieldValues: {}
      });
    }
  }, {
    key: "toggleVisibility",
    value: function toggleVisibility() {
      var _this2 = this;

      var isVisible = this.state.isVisible;
      var delay = this.props.delay;

      if (delay) {
        setTimeout(function () {
          return _this2.setState({
            isVisible: !isVisible
          });
        }, delay * 1000);
      }
    }
  }, {
    key: "submitForm",
    value: function submitForm(event) {
      var _this3 = this;

      event.stopPropagation();
      var _this$props2 = this.props,
          locationId = _this$props2.locationId,
          businessId = _this$props2.businessId,
          businessType = _this$props2.businessType;
      var isSubmitting = this.state.isSubmitting;
      var headers = {};

      if (isSubmitting) {
        return;
      }

      this.setState({
        isSubmitting: true
      });
      var formFieldValues = this.state.formFieldValues;
      var errors = this.getErrors();
      this.setState({
        errors: errors
      });

      if (Object.keys(errors).length) {
        this.setState({
          isSubmitting: false
        });
        return;
      }

      formFieldValues.location = locationId;
      var url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
      var fullUrl = "".concat(url, "businesses/").concat(businessType, "s/").concat(businessId, "/locations/").concat(locationId, "/contacts/create/");

      _axios["default"].post(fullUrl, formFieldValues, {
        headers: headers
      }).then(function () {
        _this3.formOnSuccess();
      })["catch"](function (_ref) {
        var status = _ref.response.status;

        if (status === 409) {
          _this3.formOnSuccess();
        } else {
          _this3.setState({
            isSubmitting: false
          });
        }
      });
    }
  }, {
    key: "closeEmailCapture",
    value: function closeEmailCapture() {
      var _this4 = this;

      var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      setTimeout(function () {
        _this4.clearInputs();

        _this4.updateVisibility(false);
      }, ms);
    }
  }, {
    key: "updateFormFields",
    value: function updateFormFields(key, event) {
      var formFieldValues = this.state.formFieldValues;
      formFieldValues[key] = event.target.value;
      this.clearError(key);
      this.setState({
        formFieldValues: formFieldValues
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isVisible = _this$state.isVisible,
          isSubmitting = _this$state.isSubmitting,
          isSuccess = _this$state.isSuccess,
          formFieldValues = _this$state.formFieldValues,
          errors = _this$state.errors;
      var _this$props3 = this.props,
          type = _this$props3.type,
          className = _this$props3.className,
          rest = (0, _objectWithoutProperties2["default"])(_this$props3, ["type", "className"]);
      var Body = _EmailCaptureVariants["default"][type];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "fc-email-capture".concat(className ? " ".concat(className) : '')
      }, /*#__PURE__*/_react["default"].createElement(Body, (0, _extends2["default"])({
        type: type,
        submitForm: this.submitForm,
        closeEmailCapture: this.closeEmailCapture,
        updateFormFields: this.updateFormFields,
        isVisible: isVisible,
        isSubmitting: isSubmitting,
        formFieldValues: formFieldValues,
        isSuccess: isSuccess,
        errors: errors
      }, rest)));
    }
  }]);
  return EmailCapture;
}(_react["default"].Component);

exports["default"] = EmailCapture;
EmailCapture.propTypes = {
  locationId: _propTypes["default"].number.isRequired,
  businessId: _propTypes["default"].number.isRequired,
  businessType: _propTypes["default"].string.isRequired,
  type: _propTypes["default"].oneOf(['inline', 'banner', 'modal']),
  headerText: _propTypes["default"].string,
  subheaderText: _propTypes["default"].string,
  description: _propTypes["default"].string,
  descriptionTextColor: _propTypes["default"].string,
  textColor: _propTypes["default"].string,
  bgColor: _propTypes["default"].string,
  delay: _propTypes["default"].number,
  closeDelay: _propTypes["default"].number,
  image: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    placement: _propTypes["default"].oneOf(['left', 'right', 'top', 'background'])
  }),
  darkCloseBtn: _propTypes["default"].bool,
  button: _propTypes["default"].shape({
    label: _propTypes["default"].string,
    key: _propTypes["default"].string,
    primary: _propTypes["default"].bool,
    bgColor: _propTypes["default"].string,
    textColor: _propTypes["default"].string
  }),
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    key: _propTypes["default"].oneOf(['email', 'first_name', 'last_name', 'phone'])
  }))
};
EmailCapture.defaultProps = {
  type: 'inline',
  headerText: 'Join our Mailing List',
  subheaderText: '',
  description: '',
  descriptionTextColor: 'black',
  textColor: 'black',
  bgColor: 'white',
  delay: 2,
  closeDelay: 4,
  image: null,
  darkCloseBtn: true,
  button: {
    label: 'Continue',
    key: 'clickme',
    primary: true,
    bgColor: '',
    textColor: ''
  },
  fields: [{
    label: 'Email',
    key: 'email'
  }]
};